// extracted by mini-css-extract-plugin
export var flowchartContainer = "_x-0";